export const ArrowIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83785 3.0876C5.06565 2.8598 5.435 2.8598 5.6628 3.0876L9.1628 6.5876C9.39061 6.81541 9.39061 7.18475 9.1628 7.41256L5.6628 10.9126C5.435 11.1404 5.06565 11.1404 4.83785 10.9126C4.61004 10.6848 4.61004 10.3154 4.83785 10.0876L7.92537 7.00008L4.83785 3.91256C4.61004 3.68475 4.61004 3.31541 4.83785 3.0876Z"
        fill={color}
      />
    </svg>
  );
};
